import React from 'react';
import ResultsTableView from './ResultsTableView'
import TableResultlistType from 'src/types/TableResultlistType';


type ResultsProps = {
  selectedRowKeyVal?: TableResultlistType[];
};

const Results: React.FC<ResultsProps> = () => { 
  return (<ResultsTableView/>);
};

export default Results;
